module.exports = __webpack_public_path__ + "img/location_setting_android_2.32463419.png";